import Rest from "../Base/Rest";

/**
 * @typedef {ProgramService}
 */
export default class ProgramService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = "/program";
}
